import { cn } from '@/lib/utils'

interface StepperProps {
	currentStep: number
	totalSteps: number
	stepNames?: string[]
	onStepClick?: (stepNumber: number) => void
	allowFutureClicks?: boolean
}

const Stepper = ({
	currentStep,
	totalSteps,
	stepNames = [],
	onStepClick,
	allowFutureClicks = false,
}: StepperProps) => {
	return (
		<div className="flex items-center justify-center space-x-4 md:space-x-8 mb-8">
			{Array.from({ length: totalSteps }).map((_, index) => {
				const stepNumber = index + 1
				const isActive = stepNumber === currentStep
				const isCompleted = stepNumber < currentStep
				const name = stepNames[index] || `Step ${stepNumber}`
				const canClick =
					onStepClick && (allowFutureClicks || isCompleted || isActive)

				return (
					<div
						key={stepNumber}
						className={cn(
							'flex flex-col items-center text-center',
							canClick ? 'cursor-pointer hover:opacity-80' : 'cursor-default'
						)}
						onClick={canClick ? () => onStepClick(stepNumber) : undefined}>
						<div
							className={cn(
								'w-8 h-8 rounded-full flex items-center justify-center border-2 transition-all duration-300',
								isActive
									? 'bg-primary border-primary text-primary-foreground scale-110 shadow-lg'
									: '',
								isCompleted
									? 'bg-primary border-primary text-primary-foreground'
									: '',
								!isActive && !isCompleted
									? 'bg-muted border-border text-muted-foreground'
									: ''
							)}>
							{isCompleted ? (
								<svg
									xmlns="http://www.w3.org/2000/svg"
									fill="none"
									viewBox="0 0 24 24"
									strokeWidth={3}
									stroke="currentColor"
									className="w-4 h-4">
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										d="M4.5 12.75l6 6 9-13.5"
									/>
								</svg>
							) : (
								<span className="text-sm font-medium">{stepNumber}</span>
							)}
						</div>
						<span
							className={cn(
								'mt-2 text-xs font-medium transition-colors duration-300',
								isActive ? 'text-primary' : 'text-muted-foreground'
							)}>
							{name}
						</span>
					</div>
				)
			})}
		</div>
	)
}

export default Stepper
